import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    styles: [
      '.snack-icon { float: left }',
      '.snack-text { padding-top: 2px; padding-left: 30px; color: white; font-size: 14pt }'
    ],
    template: `
    <div>
      <div class=\"snack-icon\">
        <span [style]=\"{ color: (data.type == 1 ? 'green' : (data.type == 2 ? 'orange' : 'red'))}\" class="material-icons">{{ getIcon(data.type) }}</span>
      </div>
      <div class=\"snack-text\"><span>{{ data.message }}</span></div>
    <div>`
  })
  export class NotificationExtendedComponent {
    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
    }

    public getIcon(type: number): string {
        switch(type) {
            case 1: return 'done';
            case 2: return 'warning';
            case 3: return 'close';
            default: return '';
        }
    }
  }
